module.exports = __webpack_public_path__ + "static/media/Chapter 1 Slide 1.12672e04.jpg";